export default __webpack_public_path__ + "static/media/bg2.6d0e2655.png";